import { Component, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractNewComponent } from '@unity/abstract/abstract-new.component';
import { CreatedResponseDto, ProgramCreateDto, ProgramsClient } from '@unity/clients';
import { TextboxControlComponent } from '@unity/forms/textbox-control/textbox-control.component';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionCancelSharedComponent } from '@unity/shared/composed/action-cancel-shared/action-cancel-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { CardNewSharedComponent } from '@unity/shared/composed/card-new-shared/card-new-shared.component';
import { stringFormControl } from '@unity/utils/form-controls';
import { QuickActions } from '@unity/utils/quick-actions';
import { FormGroupControlSchema, UnityRouteUrlTrees } from '@unity/utils/types';

class ProgramCreateSchema implements FormGroupControlSchema<ProgramCreateDto> {
  public code = stringFormControl();
  public name = stringFormControl();
}

@Component({
  selector: 'unity-new-program-page',
  imports: [CardNewSharedComponent, PageContainerComponent, TextboxControlComponent, ActionSharedComponent, ActionCancelSharedComponent],
  templateUrl: './new-program-page.component.html',
  styleUrl: './new-program-page.component.scss',
})
export class NewProgramPageComponent extends AbstractNewComponent<ProgramCreateDto, ProgramCreateSchema, CreatedResponseDto> {
  private readonly programsClient = inject(ProgramsClient);

  protected override readonly $contentHeader = signal('Create New Program');

  protected override createResourceFn$ = (form: FormGroup<ProgramCreateSchema>) => this.programsClient.createOne(form.getRawValue());
  protected override redirectUrlFn = (response: CreatedResponseDto): UnityRouteUrlTrees => ['/program', response.id];

  protected override newControlsFn() {
    return new ProgramCreateSchema();
  }
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
